import { render, staticRenderFns } from "./ReportWinlossGameProvider.vue?vue&type=template&id=7809872c"
import script from "./ReportWinlossGameProvider.vue?vue&type=script&lang=js"
export * from "./ReportWinlossGameProvider.vue?vue&type=script&lang=js"
import style0 from "./ReportWinlossGameProvider.vue?vue&type=style&index=0&id=7809872c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports